import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { useNavigate } from 'react-router-dom';

const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get('/employees/');
        const data = response.data;

        if (Array.isArray(data)) {
          setEmployees(data);
        } else {
          console.error("Unexpected API response:", data);
          setEmployees([]);
        }
      } catch (err) {
        console.error("Failed to load employees", err);
        setError("Failed to load employees.");
        setEmployees([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this employee?")) {
      try {
        await api.delete(`/employees/${id}`);
        setEmployees(employees.filter(emp => emp.id !== id));
        alert("Employee deleted successfully!");
      } catch (err) {
        console.error("Failed to delete employee", err);
        alert("Error deleting employee.");
      }
    }
  };

  if (loading) return (
    <div className="container mt-4 text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-2">Loading employees...</p>
    </div>
  );

  if (error) return (
    <div className="container mt-4">
      <div className="alert alert-danger">{error}</div>
      <button className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
        Back to Dashboard
      </button>
    </div>
  );

  return (
    <div className="container mt-4">
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="mb-0 text-primary">Employee List</h2>
            <div>
              <button 
                className="btn btn-success me-2" 
                onClick={() => navigate("/dashboard/employees/new")}
              >
                + Add New Employee
              </button>
              <button className="btn btn-outline-secondary" onClick={() => navigate("/dashboard")}>
                Back to Dashboard
              </button>
            </div>
          </div>
          
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Father's Name</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Blood Group</th>
                  <th>Education</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {employees.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4 text-muted">
                      No employees found.
                    </td>
                  </tr>
                ) : (
                  employees.map((emp, index) => (
                    <tr key={emp.id || index}>
                      <td><strong>{index + 1}</strong></td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div 
                            style={{
                              width: '10px',
                              height: '10px',
                              borderRadius: '50%',
                              backgroundColor: emp.profile_color || '#32CD32',
                              marginRight: '10px'
                            }}
                          />
                          {`${emp.first_name || ''} ${emp.middle_name || ''} ${emp.last_name || ''}`.trim()}
                        </div>
                      </td>
                      <td>{emp.father_name || '—'}</td>
                      <td>
                        <span className={`badge ${emp.gender === 'Male' ? 'bg-info' : emp.gender === 'Female' ? 'bg-warning' : 'bg-secondary'}`}>
                          {emp.gender || '—'}
                        </span>
                      </td>
                      <td>{emp.age || '—'}</td>
                      <td>{emp.blood_group || '—'}</td>
                      <td>{emp.education || '—'}</td>
                      <td>
                        <button 
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => navigate(`/dashboard/employees/${emp.id}`)}
                        >
                          View
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(emp.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeList;
